import React from 'react'

const Buffer = () => <section className="space" />

export default Buffer
